/**
 * @author Karl Jones
 * @email karljones@live.ie
 * @create date 2022-12-04 19:37:27
 * @modify date 2022-12-04 19:37:27
 * @desc [description]
 */

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

function useIsMobile() {
    return !useMediaQuery(useTheme().breakpoints.up('sm'));
}

function useIsTablet() {
    return !useMediaQuery(useTheme().breakpoints.between('sm', 'md'))
}

/**
 * Check if the preferences of the user are to have dark mode on or off
 * @returns true if dark mode is active, false otherwise
 */
function useDarkModeActive() {
    return useMediaQuery('(prefers-color-scheme: dark)');
}

export { useIsMobile, useIsTablet, useDarkModeActive }